import { PkCarousel } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { useState, useEffect } from 'react';

import { DataHandler } from '../../utils/DataHandler';
import type { HistoricalData } from '../../utils/types';

import DoublePlayerCarouselCard from './DoublePlayerCarouselCard';
import MultiplePlayerCarouselCard from './MultiplePlayerCarouselCard';
import SinglePlayerCarouselCard from './SinglePlayerCarouselCard';

import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

const MultipleTopscorers = ({ data, language }: { data: HistoricalData; language: string }) =>
  data.topScorers.length === 2 ? (
    <DoublePlayerCarouselCard data={data} language={language} />
  ) : (
    <MultiplePlayerCarouselCard data={data} language={language} />
  );

export const HistoricalCarousel = ({ language }) => {
  const [historicalData, setHistoricalData] = useState<HistoricalData[]>([]);
  const t = useTranslateFn();
  const tag = 'top_scorers_by_tournament';
  const titleText = t(tag);

  const breakpoints = {
    0: {
      slidesPerView: '1.1',
      slidesPerGroup: 1,
      spaceBetween: 12,
    },
    768: {
      slidesPerView: '2.5',
      slidesPerGroup: 3,
      spaceBetween: 12,
    },
    1200: {
      slidesPerView: '4',
      slidesPerGroup: 4,
      spaceBetween: 12,
    },
  };

  useEffect(() => {
    const apiInstance = DataHandler.getInstance();
    apiInstance.loadJsonCarousel().then((response) => {
      setHistoricalData(response);
    });
  }, []);

  return (
    <div className={clsx('pk-container', styles.tsHistoricalCarousel)}>
      <div className='pk-col pk-col--span-12 pk-col--span-lg-10 pk-col--offset-lg-1'>
        {titleText !== tag && !!historicalData?.length && (
          <PkCarousel breakpoints={JSON.stringify(breakpoints)}>
            <div slot='headline'>{titleText}</div>
            {historicalData.map((data) =>
              data.topScorers.length === 1 ? (
                <SinglePlayerCarouselCard key={data.season} data={data} language={language} />
              ) : (
                <MultipleTopscorers key={data.season} data={data} language={language} />
              ),
            )}
          </PkCarousel>
        )}
      </div>
    </div>
  );
};

export default HistoricalCarousel;
